export const siemWorkflowDetailsMessages = {
  en: {
    siemWorkflowDetails: {
      editWorkflow: "Edit workflow",
      description: "Description",
      tags: "Tags",
      categoryFallback: ({ id }) => `Category #${id}`,
      mitreTitle: "MITRE ATT&CK",
      isacaTitle: "ISACA Use Cases",
      mappingsAdd: "Add mapping",
      mitreLoading: "Loading MITRE mappings...",
      mitreEmpty: "No MITRE mappings available.",
      isacaLoading: "Loading ISACA mappings...",
      isacaEmpty: "No ISACA mappings available.",
      streamsTitle: "Streams",
      guidLabel: "GUID",
      streamsLinked: ({ count }) => `Linked streams: ${count}`,
      streamAdd: "Add stream",
      streamsLoading: "Loading streams...",
      streamsEmpty: "No streams linked.",
      conditionAdd: "Add condition",
      conditionEmpty: "No conditions.",
      triggerPrefix: "When the trigger",
      triggerMiddle: "and the count",
      triggerSuffix: "is reached.",
      nextStreamPrefix: "Next stream",
      nextStreamWithin: "within",
      nextStreamSuffix: "trigger.",
      nextStreamDefault: "Next stream",
      streamDefault: "Stream",
      conditionType: "Type",
      conditionField: "Field",
      conditionOperator: "Operator",
      conditionValue: "Value",
      conditionCron: "Cron expression",
      conditionFilter: "Filter",
      conditionGroup: "Group",
      conditionDisplayField: "Display Field",
      conditionTimeWindow: "Time window",
      operatorEqual: "Equal",
      operatorNotEqual: "Not equal",
      triggerOperatorIs: "is",
      triggerOperatorIsNot: "is not",
      minutes: "Minutes",
      hours: "Hours",
      streamsSave: "Save",
      streamAddDialogTitle: "Add stream",
      streamSearch: "Search",
      streamNone: "No streams found.",
      streamColName: "Name",
      streamColCategory: "Category",
      streamColSubcategory: "Subcategory",
      streamColScope: "Scope",
      streamScopeManaged: "Managed",
      streamScopeCommunity: "Community",
      streamScopeCompany: "Company",
      streamFilterAllCategories: "All categories",
      streamFilterAllScopes: "All scopes",
      streamLinked: "Linked",
      streamAddAction: "Add",
      streamClose: "Close",
      conditionAddDialogTitle: "Add condition",
      mitreDialogTitleCreate: "Add MITRE mapping",
      mitreDialogTitleEdit: "Edit MITRE mapping",
      mitreTactic: "MITRE Tactic",
      mitreTechnique: "MITRE Technique (optional)",
      mitreConfidence: "Confidence",
      mitreRationale: "Rationale (optional)",
      isacaDialogTitleCreate: "Add ISACA mapping",
      isacaDialogTitleEdit: "Edit ISACA mapping",
      isacaUseCase: "ISACA Use Case",
      isacaConfidence: "Confidence",
      isacaRationale: "Rationale (optional)",
      streamSearchPlaceholder: "Search",
      workflowLanguage: "Language",
    },
    siemWorkflowDetailsNotifications: {
      workflowLoadFailed: "Failed to load workflow.",
      tagsLoadFailed: "Failed to load tags.",
      mitreLoadFailed: "Failed to load MITRE tactics.",
      mitreTechniquesFailed: "Failed to load MITRE techniques.",
      isacaLoadFailed: "Failed to load ISACA use cases.",
      workflowSaved: "Saved",
      workflowUpdated: "Workflow updated.",
      saveFailed: "Save failed.",
      streamAdded: "Stream added",
      streamRemoved: "Stream removed",
      streamRemoveFailed: "Failed to remove stream.",
      deleteFailed: "Delete failed.",
      reorderFailed: "Reorder failed.",
      mitreValidation: "Validation",
      mitrePickTactic: "Please select a MITRE tactic.",
      mitreUpdated: "MITRE mapping updated.",
      mitreCreated: "MITRE mapping created.",
      mitreDeleted: "MITRE mapping deleted.",
      mitreDeleteConfirm: "Delete MITRE mapping?",
      isacaValidation: "Validation",
      isacaPickUseCase: "Please select an ISACA use case.",
      isacaUpdated: "ISACA mapping updated.",
      isacaCreated: "ISACA mapping created.",
      isacaDeleted: "ISACA mapping deleted.",
      isacaDeleteConfirm: "Delete ISACA mapping?",
      conditionCreated: "Condition created.",
      conditionDeleted: "Condition deleted.",
      conditionDeleteFailed: "Delete failed.",
      streamSaveSuccess: "Changes saved.",
    },
  },
  de: {
    siemWorkflowDetails: {
      editWorkflow: "Workflow bearbeiten",
      description: "Beschreibung",
      tags: "Tags",
      categoryFallback: ({ id }) => `Kategorie #${id}`,
      mitreTitle: "MITRE ATT&CK",
      isacaTitle: "ISACA Use Cases",
      mappingsAdd: "Mapping hinzufuegen",
      mitreLoading: "MITRE Mappings werden geladen...",
      mitreEmpty: "Keine MITRE Mappings vorhanden.",
      isacaLoading: "ISACA Mappings werden geladen...",
      isacaEmpty: "Keine ISACA Mappings vorhanden.",
      streamsTitle: "Streams",
      guidLabel: "GUID",
      streamsLinked: ({ count }) => `Verknuepfte Streams: ${count}`,
      streamAdd: "Stream hinzufuegen",
      streamsLoading: "Streams werden geladen...",
      streamsEmpty: "Keine Streams verknuepft.",
      conditionAdd: "Condition hinzufuegen",
      conditionEmpty: "Keine Conditions.",
      triggerPrefix: "Wenn der Trigger",
      triggerMiddle: "wird und die Anzahl",
      triggerSuffix: "erreicht wird.",
      nextStreamPrefix: "Naechster Stream",
      nextStreamWithin: "innerhalb",
      nextStreamSuffix: "ausloesen.",
      nextStreamDefault: "Naechster Stream",
      streamDefault: "Stream",
      conditionType: "Typ",
      conditionField: "Feld",
      conditionOperator: "Operator",
      conditionValue: "Wert",
      conditionCron: "Cron-Ausdruck",
      conditionFilter: "Filter",
      conditionGroup: "Group",
      conditionDisplayField: "Display Field",
      conditionTimeWindow: "Zeitfenster",
      operatorEqual: "Gleich",
      operatorNotEqual: "Ungleich",
      triggerOperatorIs: "ist",
      triggerOperatorIsNot: "ist nicht",
      minutes: "Minuten",
      hours: "Stunden",
      streamsSave: "Speichern",
      streamAddDialogTitle: "Stream hinzufuegen",
      streamSearch: "Suche",
      streamNone: "Keine Streams gefunden.",
      streamColName: "Name",
      streamColCategory: "Kategorie",
      streamColSubcategory: "Unterkategorie",
      streamColScope: "Sichtbarkeit",
      streamScopeManaged: "Verwaltet",
      streamScopeCommunity: "Community",
      streamScopeCompany: "Unternehmen",
      streamFilterAllCategories: "Alle Kategorien",
      streamFilterAllScopes: "Alle Sichtbarkeiten",
      streamLinked: "Verknuepft",
      streamAddAction: "Hinzufuegen",
      streamClose: "Schliessen",
      conditionAddDialogTitle: "Condition hinzufuegen",
      mitreDialogTitleCreate: "MITRE Mapping hinzufuegen",
      mitreDialogTitleEdit: "MITRE Mapping bearbeiten",
      mitreTactic: "MITRE Tactic",
      mitreTechnique: "MITRE Technique (optional)",
      mitreConfidence: "Confidence",
      mitreRationale: "Rationale (optional)",
      isacaDialogTitleCreate: "ISACA Mapping hinzufuegen",
      isacaDialogTitleEdit: "ISACA Mapping bearbeiten",
      isacaUseCase: "ISACA Use Case",
      isacaConfidence: "Confidence",
      isacaRationale: "Rationale (optional)",
      streamSearchPlaceholder: "Suche",
      workflowLanguage: "Sprache",
    },
    siemWorkflowDetailsNotifications: {
      workflowLoadFailed: "Workflow laden fehlgeschlagen.",
      tagsLoadFailed: "Tags laden fehlgeschlagen.",
      mitreLoadFailed: "MITRE Tactics laden fehlgeschlagen.",
      mitreTechniquesFailed: "MITRE Techniques laden fehlgeschlagen.",
      isacaLoadFailed: "ISACA Use Cases laden fehlgeschlagen.",
      workflowSaved: "Gespeichert",
      workflowUpdated: "Workflow wurde aktualisiert.",
      saveFailed: "Speichern fehlgeschlagen.",
      streamAdded: "Stream hinzugefuegt",
      streamRemoved: "Stream entfernt",
      streamRemoveFailed: "Stream entfernen fehlgeschlagen.",
      deleteFailed: "Loeschen fehlgeschlagen.",
      reorderFailed: "Neu sortieren fehlgeschlagen.",
      mitreValidation: "Validierung",
      mitrePickTactic: "Bitte eine MITRE Tactic auswaehlen.",
      mitreUpdated: "MITRE Mapping wurde aktualisiert.",
      mitreCreated: "MITRE Mapping wurde erstellt.",
      mitreDeleted: "MITRE Mapping geloescht.",
      mitreDeleteConfirm: "MITRE Mapping wirklich loeschen?",
      isacaValidation: "Validierung",
      isacaPickUseCase: "Bitte einen ISACA Use Case auswaehlen.",
      isacaUpdated: "ISACA Mapping wurde aktualisiert.",
      isacaCreated: "ISACA Mapping wurde erstellt.",
      isacaDeleted: "ISACA Mapping geloescht.",
      isacaDeleteConfirm: "ISACA Mapping wirklich loeschen?",
      conditionCreated: "Condition wurde erstellt.",
      conditionDeleted: "Condition geloescht.",
      conditionDeleteFailed: "Loeschen fehlgeschlagen.",
      streamSaveSuccess: "Aenderungen wurden gespeichert.",
    },
  },
};
